import type { Resolver } from 'cpool-schemas';
import { z } from 'zod';

import { BanksTableDefinitionZod } from '../tables';

type Arguments = {
    position?: number;
};
export const schemaLoanRequestResolver_GetBanks = z.array(BanksTableDefinitionZod);

export type SchemaLoanRequestResolver_GetBanks = z.infer<typeof schemaLoanRequestResolver_GetBanks>;

export type LoanRequestResolver_GetBanks = Resolver<Arguments, SchemaLoanRequestResolver_GetBanks>;
